import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {ContentService} from '../../networking/services/content/content.service';

@Injectable({
  providedIn: 'root',
})
export class ContentManager {
  constructor(private contentService: ContentService) {}

  getContent(tag: string) {
    const params = {tag};
    return this.contentService.get(params).pipe(map(res => res));
  }
}
